import { render } from "./padel-button.template.html?vue&type=template&id=499146e1&scoped=true"
import script from "./PadelButton.vue?vue&type=script&lang=ts"
export * from "./PadelButton.vue?vue&type=script&lang=ts"

import "./PadelButton.vue?vue&type=style&index=0&id=499146e1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-499146e1"

export default script